import { ScopeOption } from '../types';

/** Зона по аптекам: чьи исключения окна ввода оператор видит и меняет */
const zoneScope = (what: string): ScopeOption[] => [
  { value: 'all', label: 'Вся сеть', description: `${what}: все аптеки сети`, badgeColor: '#10b981' },
  { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: `${what}: аптеки из myPharmacy оператора`, badgeColor: '#3b82f6' },
  { value: 'own_region', label: 'Свой регион', description: `${what}: аптеки своего города (cityId)`, badgeColor: '#06b6d4' },
  { value: 'none', label: 'Запрещено', description: `${what}: нет доступа`, badgeColor: '#ef4444' }
];

/**
 * Варианты скоупов для модуля «Таблицы и справочники» (tables.*)
 */
export const tablesScopes: Record<string, ScopeOption[]> = {
  // Навигация
  'tables.menu': [
    { value: 'true', label: 'Включено', description: 'Отображать пункт «Таблица» в боковом меню', badgeColor: '#10b981' },
    { value: 'none', label: 'Выключено', description: 'Пункт скрыт из бокового меню', badgeColor: '#ef4444' }
  ],

  // Таблица выручки (table_info)
  'tables.revenue.view': [
    { value: 'true', label: 'Разрешено', description: 'Доступ к просмотру колонок и формул таблицы выручки', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Вкладка таблицы выручки недоступна', badgeColor: '#ef4444' }
  ],
  'tables.revenue.create': [
    { value: 'true', label: 'Разрешено', description: 'Создание новых колонок в форме отчетов', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Создание новых колонок заблокировано', badgeColor: '#ef4444' }
  ],
  'tables.revenue.edit': [
    { value: 'true', label: 'Разрешено', description: 'Изменение параметров, формул и групп колонок', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Редактирование колонок заблокировано', badgeColor: '#ef4444' }
  ],
  'tables.revenue.delete': [
    { value: 'true', label: 'Разрешено', description: 'Удаление колонок из структуры ежедневного отчета', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Удаление колонок заблокировано', badgeColor: '#ef4444' }
  ],
  'tables.revenue.formula.edit': [
    { value: 'true', label: 'Разрешено', description: 'Задавать и менять формулы колонок в конструкторе (вместе с правом на создание или редактирование колонок)', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Формулы и блокировка ввода колонок только для просмотра', badgeColor: '#ef4444' }
  ],
  'tables.revenue.sync.view': [
    { value: 'true', label: 'Разрешено', description: 'Видеть, в скольких таблицах аптек есть колонка («N из 509»), и по каким таблицам операция не прошла', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Охват колонок по таблицам аптек скрыт', badgeColor: '#ef4444' }
  ],
  'tables.revenue.sync.run': [
    { value: 'true', label: 'Разрешено', description: 'Добавлять колонку в таблицы аптек и повторять операцию. На время работы данные аптек блокируются', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Добавление колонок в таблицы аптек заблокировано', badgeColor: '#ef4444' }
  ],
  'tables.revenue.lock.view': [
    { value: 'true', label: 'Разрешено', description: 'Видеть, идет ли обслуживание таблиц аптек, кто его запустил и до какого времени действует блокировка', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Состояние блокировки данных скрыто', badgeColor: '#ef4444' }
  ],
  'tables.revenue.lock.release': [
    { value: 'true', label: 'Разрешено', description: 'Снимать блокировку данных аптек вручную, если операция оборвалась. Действие пишется в журнал', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Снятие блокировки недоступно', badgeColor: '#ef4444' }
  ],
  'tables.revenue.recalc.preview': [
    { value: 'true', label: 'Разрешено', description: 'Смотреть, какие значения за прошлые дни изменятся при пересчете (было → стало), ничего не записывая', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Предпросмотр пересчета истории недоступен', badgeColor: '#ef4444' }
  ],
  'tables.revenue.recalc.run': [
    { value: 'true', label: 'Разрешено', description: 'Пересчитывать расчетные колонки за прошлые дни по текущим формулам. На время работы данные аптек блокируются', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Пересчет истории заблокирован', badgeColor: '#ef4444' }
  ],

  // Окно ввода таблицы выручки (settings + revenue_entry_overrides)
  'tables.revenue.entry.view': zoneScope('Параметры окна ввода и исключения аптек'),
  'tables.revenue.entry.schedule': [
    { value: 'true', label: 'Разрешено', description: 'Менять время открытия и закрытия ввода для всей сети', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Окно ввода сети только для просмотра', badgeColor: '#ef4444' }
  ],
  'tables.revenue.entry.extend': [
    { value: 'true', label: 'Разрешено', description: 'Продлевать ввод текущей даты для всей сети, не дольше 24 часов', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Продление для сети недоступно', badgeColor: '#ef4444' }
  ],
  'tables.revenue.entry.unlock': [
    { value: 'true', label: 'Разрешено', description: 'Разблокировать таблицу для всей сети без учета времени, не дольше 24 часов', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Разблокировка для сети недоступна', badgeColor: '#ef4444' }
  ],
  'tables.revenue.entry.personal': [
    { value: 'true', label: 'Разрешено', description: 'Продление и разблокировка для отдельных аптек своей зоны, не дольше 24 часов', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Персональные продление и разблокировка недоступны', badgeColor: '#ef4444' }
  ],
  'tables.revenue.entry.date': [
    { value: 'true', label: 'Разрешено', description: 'Менять дату ввода отдельным аптекам своей зоны (за последние 6 месяцев), не дольше 24 часов', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Персональная смена даты ввода недоступна', badgeColor: '#ef4444' }
  ],
  'tables.revenue.entry.date_network': [
    { value: 'true', label: 'Разрешено', description: 'Менять дату ввода всей сети с повторным вводом даты, не дольше 24 часов', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Смена даты ввода для сети недоступна', badgeColor: '#ef4444' }
  ],

  // Справочник регионов (regions)
  'tables.regions.view': [
    { value: 'true', label: 'Разрешено', description: 'Доступ к справочнику городов и регионов', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Вкладка списка регионов недоступна', badgeColor: '#ef4444' }
  ],
  'tables.regions.create': [
    { value: 'true', label: 'Разрешено', description: 'Создание новых городов и регионов', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Добавление регионов заблокировано', badgeColor: '#ef4444' }
  ],
  'tables.regions.edit': [
    { value: 'true', label: 'Разрешено', description: 'Изменение наименований городов и регионов', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Редактирование регионов заблокировано', badgeColor: '#ef4444' }
  ],
  'tables.regions.delete': [
    { value: 'true', label: 'Разрешено', description: 'Удаление городов/регионов из системы', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Удаление регионов заблокировано', badgeColor: '#ef4444' }
  ],

  // Поля мат. отчета (mathreportfields)
  'tables.math_fields.view': [
    { value: 'true', label: 'Разрешено', description: 'Доступ к структуре колонок материального отчета', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Вкладка полей мат. отчета недоступна', badgeColor: '#ef4444' }
  ],
  'tables.math_fields.create': [
    { value: 'true', label: 'Разрешено', description: 'Добавление новых полей в материальный отчет', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Создание полей мат. отчета заблокировано', badgeColor: '#ef4444' }
  ],
  'tables.math_fields.edit': [
    { value: 'true', label: 'Разрешено', description: 'Изменение свойств и флага редактируемости колонок', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Редактирование полей мат. отчета заблокировано', badgeColor: '#ef4444' }
  ],
  'tables.math_fields.delete': [
    { value: 'true', label: 'Разрешено', description: 'Удаление полей из структуры материального отчета', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Удаление полей мат. отчета заблокировано', badgeColor: '#ef4444' }
  ]
};
